import React, { useEffect, useState } from "react";
import "./CancelModal.css";

const SelectBagTypyModel = ({ show, onClose, onSubmit, options = [], selectedValue = "" }) => {
  const [selected, setSelected] = useState("");

  useEffect(() => {
    if (show) setSelected(String(selectedValue));
  }, [show, selectedValue]);

  if (!show) return null;

  const bagOptions = Array.isArray(options) ? options : [];

  return (
    <div className="modal-backdrop-custom">
      <div className="modal-box" role="dialog" aria-modal="true" aria-label="Select Shopping Bag">

        {/* Header */}
        <div className="review-popup-header">
          <h2 className="review-popup-title">Select Shopping Bag</h2>
          <button type="button" className="review-popup-close" aria-label="Close shopping bag selection" onClick={onClose}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="modal-body">
          {bagOptions.length === 0 && (
            <p className="mb-0">No bag options available</p>
          )}

          {bagOptions.map((option, index) => {
            const optionLabel = typeof option === "string" ? option : option.label;
            const optionId = typeof option === "string" ? option : option.id || optionLabel;

            return (
            <label className="radio-row" key={optionId || index}>
              <span>{optionLabel}</span>
              <input
                type="radio"
                name="shoppingBag"
                checked={selected === String(optionId)}
                onChange={() => setSelected(String(optionId))}
              />
            </label>
            );
          })}
        </div>

        <button
          type="button"
          className="submit-btn-full"
          disabled={!bagOptions.some((option) => String(typeof option === "string" ? option : option.id || option.label) === selected)}
          onClick={() => {
            const option = bagOptions.find((item) => String(typeof item === "string" ? item : item.id || item.label) === selected);
            if (option) onSubmit(typeof option === "string" ? option : option.label, option);
          }}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default SelectBagTypyModel;
